import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import appConfig from "@/app.config";
import { mapGetters } from "vuex";
import Alerts from "@/components/alerts.vue";
import Translations from "./components/translations.vue";
import MainModal from "./components/elements/main-modal.vue";
import IdleLogout from "./components/elements/idle-logout.vue";
import PortalPasswordNotice from "./components/portal/portal-password-notice.vue";
import PortalLegalRenewal from "./components/portal/portal-legal-renewal.vue";
const passwordNoticeKey = "xmed_portal_password_notice_seen_v1";
function hasSeenPasswordNotice() {
  try {
    if (document.cookie.split(";").some(cookie => cookie.trim() === `${passwordNoticeKey}=1`)) return true;
  } catch (error) {
    // Egyes privát böngészési módokban a cookie-k le vannak tiltva.
  }
  try {
    return window.localStorage.getItem(passwordNoticeKey) === "1";
  } catch (error) {
    return false;
  }
}
function rememberPasswordNotice() {
  try {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${passwordNoticeKey}=1; Max-Age=315360000; Path=/; SameSite=Lax${secure}`;
  } catch (error) {
    // A localStorage még ilyenkor is megőrizheti a megjelenítés tényét.
  }
  try {
    window.localStorage.setItem(passwordNoticeKey, "1");
  } catch (error) {
    // Ha mindkét tároló tiltott, a következő látogatáskor újra megjelenik.
  }
}
export default {
  name: "XmedApp",
  components: {
    MainModal,
    Translations,
    Alerts,
    IdleLogout,
    PortalPasswordNotice,
    PortalLegalRenewal
  },
  data() {
    return {
      showPasswordNotice: !hasSeenPasswordNotice(),
      legalBlocking: false
    };
  },
  mounted() {
    this.rememberVisiblePasswordNotice();
    window.addEventListener("pageshow", this.onPageShow);
  },
  beforeUnmount() {
    window.removeEventListener("pageshow", this.onPageShow);
  },
  methods: {
    rememberVisiblePasswordNotice() {
      if (this.showPasswordNotice && !this.legalBlocking) this.$nextTick(rememberPasswordNotice);
    },
    onPageShow(event) {
      // A böngésző visszalépéskor a teljes portált a bfcache-ből is
      // visszaállíthatja új komponens-példány létrehozása nélkül.
      if (event.persisted) {
        this.$refs.legalRenewal?.refresh();
        this.showPasswordNotice = !hasSeenPasswordNotice();
        this.rememberVisiblePasswordNotice();
      }
    }
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'user/authenticated',
      translations: 'trans/translations',
      aliases: 'trans/aliases',
      locale: 'trans/locale',
      configuration: 'app/configuration',
      translationsLoaded: 'trans/loaded'
    })
  },
  watch: {
    legalBlocking(value) {
      if (!value) this.rememberVisiblePasswordNotice();
    },
    user: {
      immediate: true,
      deep: true,
      handler: function (user) {
        if (this.authenticated && !user?.id) {
          console.log('user', this.authenticated, user);
          this.$store.dispatch('user/authenticated');
        }
      }
    },
    authenticated: {
      immediate: true,
      deep: true,
      handler: function (authenticated) {
        if (authenticated && !this.user?.id) {
          console.log('authenticated', authenticated, this.user);
          this.$store.dispatch('user/authenticated');
        }
      }
    }
  },
  created() {
    console.log(this.$router);
  }
};